import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const logo = require('./logo.png');
  return (
    <>
      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid navtext">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarTogglerDemo01"
            aria-controls="navbarTogglerDemo01"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          
            <Link className="navbar-brand title" to={'/'}>
              <img src={logo} height={40} />
            </Link>
            <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">

              <li className="nav-item">
                <Link className="nav-link" aria-current="page" to="/">
                  Explore
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/offers">
                  Offers
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/profile">
                    Profile
                </Link>
              </li>
              &nbsp;&nbsp;
              <li className="nav-item">
              <Link to="/create-listing"><button className="btn btn-sm btn-light mt-1">Post Property</button></Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
